import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingBag } from "lucide-react";

export default function ShopPage() {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="font-display text-3xl sm:text-4xl font-bold">Boutique</h1>
      <p className="text-sm text-muted-foreground mt-1">Crée ta gamme : t-shirt, hoodie, casquette — imprimés en Polynésie.</p>
      <Card className="mt-6 p-8 text-center">
        <ShoppingBag className="h-10 w-10 mx-auto text-[hsl(var(--aito-lagoon))]" />
        <h2 className="font-display text-2xl font-bold mt-3">Bientôt disponible</h2>
        <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">La boutique athlètes arrivera avec la version 2 : produits personnalisés, partenaires imprimeurs locaux, paiement sécurisé et reversement aux sportifs.</p>
        <Button disabled className="mt-5">Notifie-moi au lancement</Button>
      </Card>
    </div>
  );
}
